// eslint-disable-next-line @typescript-eslint/naming-convention
export const AppConfigs = {
  BaseGrbMapLayerUrl: '/appl/configuratieservice/geo-url/GRB/wmts',
  GeoLocation: '/appl/configuratieservice/geo-url/geolocation',
};

export const AppConfigKeys = [AppConfigs.BaseGrbMapLayerUrl];
